import { useState } from "react";
import { Row, Col, Select } from "antd";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import SelectArrow from "../../../../../components/selectArrow";
import { years, months } from "../../../../../assets/constants";
import settingsActions from "../../../../../redux/settings/actions";
import styles from "./style.module.scss";
import "./antCustomStyle.scss";

const AddNewAchievement = ({ close }) => {
  const dispatch = useDispatch()
  const [month, setMonth] = useState();
  const [year, setYear] = useState();
  const [title, setTitle] = useState();
  const [description, setDescription] = useState("");
  const [error, setError] = useState()

  const save = ()=>{
    if (!title) {
      setError(true)
      return
    }
    setError(false)
    close();
    dispatch({
      type: settingsActions.CREATE_NEW_ACHIEVEMENT,
      payload: {
        type: 'achievement',
        month,
        year,
        title,
        description,
        hidden: false
      }
    })
  }

  const onDescriptionChange = (e) => {
    const value = e.target.value;
    if (value && value.length < 2000) {
      setDescription(value);
    } else {
      setDescription("");
    }
  };
  return (
    <div
      className={`${styles.addNewAchievementContainer} addNewAchievementContainer`}
    >
      <Row
        justify="space-between"
        align="center"
        className={styles.topContainer}
      >
        <Col span={11} className={styles.title}>
          Achievements
        </Col>
        <Col>
          <button
            className={styles.cancelButton}
            htmlType="submit"
            onClick={close}
          >
            Cancel
          </button>
          <button
            className={styles.saveButton}
            htmlType="submit"
            onClick={save}
          >
            Add
          </button>
        </Col>
      </Row>
      <div className={styles.formContainer}>
        <div className={styles.formGroup}>
          <label htmlFor>
            Title <span>*</span>
          </label>
          <input onChange={(e) => setTitle(e.target.value)} />
          {error && <span style={{color:'red', fontSize:'12px'}}>Title Required</span>}
        </div>
        <Row gutter={16} justify="space-between">
          <Col span={9}>
            <div className={styles.formGroup}>
              <label htmlFor>Month</label>
              <Select
                suffixIcon={SelectArrow}
                onChange={(e) => setMonth(e)}
                className={styles.select}
              >
                {months.map((m) => (
                  <Select.Option key={m} value={m}>
                    {m}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={9}>
            <div className={styles.formGroup}>
              <label htmlFor>Year</label>
              <Select
                suffixIcon={SelectArrow}
                onChange={(e) => setYear(e)}
                className={styles.select}
              >
                {years().map((y) => (
                  <Select.Option key={y} value={y}>
                    {y}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={3} />
        </Row>
        <div className={styles.formGroup}>
          <label htmlFor>Description</label>
          <textarea rows="4" onChange={(e) => onDescriptionChange(e)} />
          <div className={styles.stringLength}>{description.length}/2000</div>
        </div>
      </div>
    </div>
  );
};

AddNewAchievement.propTypes = {
  close: PropTypes.func,
};

AddNewAchievement.defaultProps = {
  close: () => {
    return true;
  },
};

export default AddNewAchievement;
